"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfBroadcastNotificationDto = instanceOfBroadcastNotificationDto;
exports.BroadcastNotificationDtoFromJSON = BroadcastNotificationDtoFromJSON;
exports.BroadcastNotificationDtoFromJSONTyped = BroadcastNotificationDtoFromJSONTyped;
exports.BroadcastNotificationDtoToJSON = BroadcastNotificationDtoToJSON;
exports.BroadcastNotificationDtoToJSONTyped = BroadcastNotificationDtoToJSONTyped;
var BroadcastRecipientDto_1 = require("./BroadcastRecipientDto");
/**
 * Check if a given object implements the BroadcastNotificationDto interface.
 */
function instanceOfBroadcastNotificationDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('title' in value) || value['title'] === undefined)
        return false;
    if (!('message' in value) || value['message'] === undefined)
        return false;
    if (!('audienceType' in value) || value['audienceType'] === undefined)
        return false;
    if (!('recipientCount' in value) || value['recipientCount'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('sentBy' in value) || value['sentBy'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    if (!('recipients' in value) || value['recipients'] === undefined)
        return false;
    return true;
}
function BroadcastNotificationDtoFromJSON(json) {
    return BroadcastNotificationDtoFromJSONTyped(json, false);
}
function BroadcastNotificationDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'title': json['title'],
        'message': json['message'],
        'deepLink': json['deepLink'] == null ? undefined : json['deepLink'],
        'audienceType': json['audienceType'],
        'recipientCount': json['recipientCount'],
        'status': json['status'],
        'sentBy': json['sentBy'],
        'sentByEmail': json['sentByEmail'] == null ? undefined : json['sentByEmail'],
        'sentAt': json['sentAt'] == null ? undefined : json['sentAt'],
        'createdAt': json['createdAt'],
        'recipients': (json['recipients'].map(BroadcastRecipientDto_1.BroadcastRecipientDtoFromJSON)),
    };
}
function BroadcastNotificationDtoToJSON(json) {
    return BroadcastNotificationDtoToJSONTyped(json, false);
}
function BroadcastNotificationDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'title': value['title'],
        'message': value['message'],
        'deepLink': value['deepLink'],
        'audienceType': value['audienceType'],
        'recipientCount': value['recipientCount'],
        'status': value['status'],
        'sentBy': value['sentBy'],
        'sentByEmail': value['sentByEmail'],
        'sentAt': value['sentAt'],
        'createdAt': value['createdAt'],
        'recipients': (value['recipients'].map(BroadcastRecipientDto_1.BroadcastRecipientDtoToJSON)),
    };
}
